import React from 'react';

const getWindowOptions = function() {
  const width = Math.min(window.innerWidth, 500);
  const height = 350;
  const left = window.innerWidth / 2 - width / 2;
  const top = window.innerHeight / 2 - height / 2;

  return ['resizable,scrollbars,status', 'height=' + height, 'width=' + width, 'left=' + left, 'top=' + top].join();
};

export const ShareButton = ({ name, ...props }) => {
  return (
    <a
      {...props}
      onClick={event => {
        event.preventDefault();
        const win = window.open(props.href, name, getWindowOptions());
        win.opener = null;
      }}
    />
  );
};
